(function() {
    'use strict';
    
    const countdown = {
        initCountdown: function () {
            var countdownAnnouncementElm = document.querySelectorAll('[data-countdown-announcement]'),
                countdownElm = Array.from(document.querySelectorAll('[data-countdown]')).filter(el => !el.hasAttribute('data-countdown-id')),
                countdownNewsletter = document.querySelectorAll('[data-countdown-time]');

            if (countdownAnnouncementElm.length) {
                countdownAnnouncementElm.forEach(function (self) {
                    var countdownAnnouncement = self.dataset.countdownValue,
                        countdownAnnouncementDate = new Date(countdownAnnouncement).getTime();

                    if (isNaN(countdownAnnouncementDate)) return;

                    var countdownAnnouncementFunction = setInterval(function () {
                        var now = new Date().getTime(),
                            distance = countdownAnnouncementDate - now;

                        if (distance < 0) {
                            clearInterval(countdownAnnouncementFunction);
                            if (self.classList.contains('hide--countdown')) {
                                self.remove();
                            }
                            else {
                                const thisItem = self.closest('.announcement-bar__message');
                                // Slick removed - announcement bar slider needs Swiper implementation
                                if (thisItem) {
                                    thisItem.remove();
                                }
                            }
                        } else {
                            var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';

                            strCountDown = '<div class="clock-item"><span class="num">' + days + '</span><span class="text">' + window.countdown.days + '</span></div>\
                                            <div class="clock-item"><span class="num">'+ hours + '</span><span class="text">' + window.countdown.hours + '</span></div>\
                                            <div class="clock-item"><span class="num">'+ minutes + '</span><span class="text">' + window.countdown.mins + '</span></div>\
                                            <div class="clock-item"><span class="num">'+ seconds + '</span><span class="text">' + window.countdown.secs + '</span></div>';

                            self.innerHTML = strCountDown;
                        }
                    }, 1000);
                });
            }

            if (countdownElm.length) {
                countdownElm.forEach(function (self) {
                    var countDown = self.dataset.countdownValue,
                        countDownDate = new Date(countDown).getTime();

                    if (isNaN(countDownDate)) return;

                    var countdownfunction = setInterval(function () {
                        var now = new Date().getTime(),
                            distance = countDownDate - now;

                        if (distance < 0) {
                            clearInterval(countdownfunction);
                            if (self.classList.contains('hide--countdown')) {
                                self.remove();
                            }
                            else {
                                const shopifySection = self.closest('.shopify-section');
                                if (shopifySection) shopifySection.remove();
                            }
                        } else {
                            var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';
                            if (self.classList.contains('product-countdown-block')) {
                                const haloBlockHeader = document.querySelector('.halo-block-header');
                                if (haloBlockHeader && haloBlockHeader.classList.contains('countdown_style_2')) {
                                    strCountDown = '<div class="clock-item"><span class="num">' + days + window.countdown.d + '</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+ hours + window.countdown.h + '</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+ minutes + window.countdown.m + '</span><span class="icon">:</span></div>\
                                                <div class="clock-item"><span class="num">'+ seconds + window.countdown.s + '</span><span class="icon"></span></div>';
                                } else {
                                    strCountDown = `<div class="clock-item"><span class="num">${days}d&nbsp;</span></div>
                                    <div class="clock-item"><span class="num">${hours}:</span></div>
                                    <div class="clock-item"><span class="num">${minutes}:</span></div>
                                    <div class="clock-item"><span class="num">${seconds}</span></div>`;
                                }
                            } else {
                                strCountDown = '<div class="clock-item"><span class="num">' + days + '</span><span class="text">' + window.countdown.days + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ hours + '</span><span class="text">' + window.countdown.hours + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ minutes + '</span><span class="text">' + window.countdown.mins + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ seconds + '</span><span class="text">' + window.countdown.secs + '</span></div>';
                            }
                            // Fixed: Changed from jQuery .html() to vanilla JS innerHTML
                            self.innerHTML = strCountDown;
                        }
                    }, 1000);
                });
            }

            if (countdownNewsletter.length) {
                function initCountdown(element) {
                    const countdownTime = new Date(element.dataset.countdownTime).getTime();
                    if (isNaN(countdownTime)) return;

                    const intervalId = setInterval(function () {
                        const now = new Date().getTime();
                        const distance = countdownTime - now;

                        if (distance < 0) {
                            clearInterval(intervalId);
                            element.remove();
                        } else {
                            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                            const content = `
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${days}</span>
                            <span class="dis-block text uppercase">${window.countdown.day}ays</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${hours}</span>
                            <span class="dis-block text uppercase">${window.countdown.hour}ours</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${minutes}</span>
                            <span class="dis-block text uppercase">${window.countdown.min}ins</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${seconds}</span>
                            <span class="dis-block text uppercase">${window.countdown.sec}econds</span>
                          </span>`;

                            const countdownEl = element.querySelector('.countdown');
                            if (countdownEl) {
                                countdownEl.innerHTML = content;
                                countdownEl.classList.add('show');
                            }
                            const parent = element.parentElement;
                            if (parent) parent.classList.remove('hidden');
                        }
                    }, 1000);
                }

                countdownNewsletter.forEach(function (element) {
                    initCountdown(element);
                });
            }
        },

        collectionCountdown: function () {
            var countdownElm = document.querySelectorAll('[data-collection-countdown]');

            if (countdownElm.length) {
                countdownElm.forEach(function (self) {
                    var countDownCollection = (self) => {
                        var countDown = self.dataset.collectionCountdownValue,
                            countDownDate = new Date(countDown).getTime(),
                            countDownText = window.countdown.text,
                            now = new Date().getTime(),
                            distance = countDownDate - now;

                        if (isNaN(countDownDate)) return;

                        if (distance < 0) {
                            clearInterval(countDownCollection);
                            if (self.classList.contains('hide--countdown')) {
                                self.remove();
                            }
                        } else {
                            var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                                hours = `0${Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))}`.slice(-2),
                                minutes = `0${Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2),
                                seconds = `0${Math.floor((distance % (1000 * 60)) / 1000)}`.slice(-2),
                                strCountDown = '';
                            if (self.classList.contains('collection-countdown')) {
                                strCountDown = '<div class="clock-item"><span class="num">' + days + '</span><span class="text">' + window.countdown.days + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ hours + '</span><span class="text">' + window.countdown.hours + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ minutes + '</span><span class="text">' + window.countdown.mins + '</span></div>\
                                                <div class="clock-item"><span class="num">'+ seconds + '</span><span class="text">' + window.countdown.secs + '</span></div>';
                            }
                            self.innerHTML = strCountDown;
                        }
                    }

                    setInterval(() => {
                        countDownCollection(self)
                    }, 1000);
                });
            }
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all countdown functions to halo
    Object.assign(window.halo, countdown);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            countdown.initCountdown();
            countdown.collectionCountdown();
        });
    } else {
        countdown.initCountdown();
        countdown.collectionCountdown();
    }
})();

